import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StaticIcon from '../StaticIcon';

var getColor = function getColor(props) {
  if (props.error) {
    return props.theme.errorColor || '#e35d6d';
  }

  return props.white ? '#fff' : '#000';
};

var Input = styled.input.withConfig({
  displayName: "TextInput__Input",
  componentId: "k8w5ak-0"
})([""]);
var Textarea = styled.textarea.withConfig({
  displayName: "TextInput__Textarea",
  componentId: "k8w5ak-1"
})(["\n  overflow: hidden; /* Firefox adds an extra newline. */\n"]);
var Label = styled.div.withConfig({
  displayName: "TextInput__Label",
  componentId: "k8w5ak-2"
})(["\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 21px;\n  text-transform: uppercase;\n  transform: translate3d(0, 100%, 0);\n  color: ", ";\n  transition: 0.2s ease all;\n  cursor: text;\n"], function (props) {
  return props.white ? '#fff' : '#000';
});
var LabelWrapper = styled.label.withConfig({
  displayName: "TextInput__LabelWrapper",
  componentId: "k8w5ak-3"
})(["\n  display: flex;\n  flex-direction: column-reverse;\n  position: relative;\n"]);
var Wrapper = styled.div.withConfig({
  displayName: "TextInput__Wrapper",
  componentId: "k8w5ak-4"
})(["\n  display: inline-block;\n  width: ", ";\n  color: ", ";\n  vertical-align: top;\n\n  ", ", ", ", input {\n    box-sizing: border-box;\n    display: block;\n    padding: 0 15px 8px 0;\n    outline: 0;\n    width: 100%;\n\n    border: 0;\n    border-radius: 0;\n    border-bottom: 2px solid ", ";\n    background: transparent;\n    color: ", ";\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 21px;\n    -webkit-appearance: none;\n\n    @media (max-width: 1024px) {\n      /* Necessary to prevent browsers like Mobile Safari from zooming in on text\n         fields when font-size is less than 16px. */\n      font-size: 16px;\n    }\n\n    &:focus {\n      border-color: ", ";\n    }\n\n    &", " ~ ", " {\n      font-size: 10px;\n      transform: translate3d(0, 0, 0);\n      color: ", ";\n      cursor: default;\n    }\n\n    &:focus ~ ", " {\n      color: ", ";\n    }\n  }\n"], function (props) {
  return props.fullWidth ? '100%' : 'auto';
}, function (props) {
  return props.white ? '#fff' : 'inherit';
}, Input, Textarea, getColor, function (props) {
  return props.white ? '#fff' : '#000';
}, function (props) {
  return props.theme.focusColor || '#7c89d3';
}, function (props) {
  return props.hasValue ? '' : ':focus';
}, Label, function (props) {
  return props.white ? '#fff' : '#7d7d7d';
}, Label, function (props) {
  return props.theme.focusColor || '#7c89d3';
});
var IconWrapper = styled.span.withConfig({
  displayName: "TextInput__IconWrapper",
  componentId: "k8w5ak-5"
})(["\n  position: absolute;\n  right: 0;\n  bottom: 12px;\n"]);
var Footer = styled.div.withConfig({
  displayName: "TextInput__Footer",
  componentId: "k8w5ak-6"
})(["\n  min-height: ", "px;\n  margin: 4px 0 0 0;\n  font-size: 10px;\n  line-height: 1.5;\n  color: ", ";\n"], function (props) {
  return props.hint ? 30 : 15;
}, getColor);
var Hint = styled.p.withConfig({
  displayName: "TextInput__Hint",
  componentId: "k8w5ak-7"
})(["\n  margin: 0;\n"]);
var Error = styled.p.withConfig({
  displayName: "TextInput__Error",
  componentId: "k8w5ak-8"
})(["\n  margin: 0;\n"]);

var TextInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TextInput, _Component);

  function TextInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      rows: _this.props.minRows,
      value: null
    });

    _defineProperty(_assertThisInitialized(_this), "updateRef", function (node) {
      return _this.field = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          tagName = _this$props.tagName;

      _this.setState({
        value: event.target.value
      });

      onChange && onChange(event);

      if (tagName === 'textarea') {
        // Reset rows in case the number of rows shrink,
        // then update the number of rows
        _this.setState({
          rows: _this.props.minRows
        }, function () {
          _this.updateRows();
        });
      }
    });

    return _this;
  }

  var _proto = TextInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        onMount = _this$props2.onMount,
        tagName = _this$props2.tagName;
    onMount && onMount(this.field);

    if (tagName === 'textarea') {
      this.baseHeight = this.field.scrollHeight;
      this.lineHeight = 21;
    }
  };

  _proto.updateRows = function updateRows() {
    // Measure height and automatically expand textarea
    // scrollHeight = baseHeight + lineHeight*rows
    var newRows = this.props.minRows + (this.field.scrollHeight - this.baseHeight) / this.lineHeight;
    this.setState({
      rows: newRows
    });
  };

  _proto.renderIcon = function renderIcon() {
    var _this$props3 = this.props,
        icon = _this$props3.icon,
        valid = _this$props3.valid;

    if (icon) {
      if (typeof icon === 'string') {
        icon = React.createElement(StaticIcon, {
          type: icon,
          size: 12
        });
      }
    } else if (valid) {
      icon = React.createElement(StaticIcon, {
        type: "check",
        size: 12
      });
    }

    return icon ? React.createElement(IconWrapper, null, icon) : null;
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        className = _this$props4.className,
        error = _this$props4.error,
        fullWidth = _this$props4.fullWidth,
        hint = _this$props4.hint,
        label = _this$props4.label,
        onChange = _this$props4.onChange,
        placeholder = _this$props4.placeholder,
        renderInput = _this$props4.renderInput,
        tagName = _this$props4.tagName,
        valid = _this$props4.valid,
        id = _this$props4.id,
        value = _this$props4.value,
        white = _this$props4.white,
        icon = _this$props4.icon,
        props = _objectWithoutPropertiesLoose(_this$props4, ["className", "error", "fullWidth", "hint", "label", "onChange", "placeholder", "renderInput", "tagName", "valid", "id", "value", "white", "icon"]);

    var newValue = value == null ? undefined : value.toString();
    var newPlaceholder = placeholder == null ? undefined : placeholder.toString();
    var hasValue = newValue || newPlaceholder || this.state.value;
    return React.createElement(Wrapper, {
      className: className,
      error: error,
      fullWidth: fullWidth,
      white: white,
      hasValue: hasValue
    }, React.createElement(LabelWrapper, {
      htmlFor: id
    }, renderInput(_objectSpread({
      ref: this.updateRef,
      error: error,
      onChange: this.handleChange,
      placeholder: newPlaceholder,
      rows: this.state.rows,
      tagName: tagName,
      type: 'text',
      value: newValue,
      id: id,
      white: white
    }, props)), label ? React.createElement(Label, _extends({
      white: white,
      hasValue: hasValue
    }, props), label) : null, this.renderIcon()), React.createElement(Footer, {
      error: error,
      hint: hint
    }, hint ? React.createElement(Hint, null, hint) : null, error ? React.createElement(Error, null, error) : null));
  };

  return TextInput;
}(Component);

_defineProperty(TextInput, "Label", Label);

_defineProperty(TextInput, "Input", Input);

_defineProperty(TextInput, "Footer", Footer);

_defineProperty(TextInput, "Hint", Hint);

_defineProperty(TextInput, "Error", Error);

_defineProperty(TextInput, "propTypes", {
  /**
   * Field default value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Callback function calling with current value
   */
  onChange: PropTypes.func,

  /**
   * Label for field
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /**
   * Error message
   */
  error: PropTypes.string,

  /**
   * Hint message
   */
  hint: PropTypes.string,

  /**
   * Show validation state for field
   */
  valid: PropTypes.bool,

  /**
   * Make input white
   */
  white: PropTypes.bool,

  /**
   * Make input white
   */
  fullWidth: PropTypes.bool,

  /**
   * A render prop for creating the field element
   */
  renderInput: PropTypes.func,

  /**
   * Choose element tag to render
   */
  tagName: PropTypes.oneOf(['input', 'textarea']).isRequired,

  /**
   * Type of input
   */
  type: PropTypes.oneOf(['email', 'number', 'password', 'search', 'text']),

  /**
   * Minimum number of rows to render for textarea
   */
  minRows: PropTypes.number,

  /**
   * Example of what should be provided to the field
   */
  placeholder: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
});

_defineProperty(TextInput, "defaultProps", {
  tagName: 'input',
  minRows: 1,
  renderInput: function renderInput(_ref) {
    var rows = _ref.rows,
        type = _ref.type,
        props = _objectWithoutPropertiesLoose(_ref, ["rows", "type"]);

    return props.tagName === 'textarea' ? React.createElement(Textarea, _extends({}, props, {
      rows: rows
    })) : React.createElement(Input, _extends({}, props, {
      type: type
    }));
  }
});

export { TextInput as default };